import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { editOrgAdmin } from "./editOrgSlice";
import { fetchOrganizationData } from "../../../pages/users/listOrganizationSlice";
import useNotification from "../../notification/useNotification";
import { isSuccessResponse } from "../../../common/utils";

interface IProps {
  orgId: string;
  email: string;
  phoneNo: string;
  orgName: string;
  address: string;
}
interface IEditBody {
  phoneNo: string;
  address: string;
}
interface IEditPayload {
  orgId: string;
  body: IEditBody;
}

export const useEditOrgAdmin = (props: IProps) => {
  const dispatch: any = useDispatch();

  const [show, setShow] = useState<boolean>(false);
  const [newPhoneNo, setNewPhoneNo] = useState<string>(props?.phoneNo);
  const [newAddress, setNewAddress] = useState<string>(props?.address);
  const isDisabled = !(newAddress?.length != 0 && newPhoneNo?.length != 0);

  const { showSuccessNotification, showWarningNotification } = useNotification();
  const handleShow = useCallback(() => setShow(true), [setShow]);
  const handleClose = useCallback(() => {
    setNewPhoneNo(props.phoneNo);
    setNewAddress(props.address);
    setShow(false);
  }, [setShow]);

  const handleKeyDown = (e) => {
    if (e.keyCode === 32) {
      setNewAddress(newAddress + " ");
    }
  };

  const handleEdit = () => {
    const editOrgPayload: IEditPayload = {
      orgId: props.orgId,
      body: {
        phoneNo: newPhoneNo,
        address: newAddress,
      },
    };
    dispatch(editOrgAdmin(editOrgPayload)).then((response) => {
      if (isSuccessResponse(response.payload)) {
        dispatch(fetchOrganizationData());
        showSuccessNotification(response.payload.message);
      }
      else {
        showWarningNotification(response.payload.response.data.message);
      }
    });
    setShow(false);
  };

  return {
    show,
    setNewPhoneNo,
    setNewAddress,
    newPhoneNo,
    newAddress,
    handleClose,
    handleShow,
    handleEdit,
    isDisabled,
    handleKeyDown,
  };
};
